import breakdownByFieldType from './breakdown-by-field-type'

import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'
import SortObjectTypes from './sort-object-types'
const { SERIE, BREAKDOWN1 } = SortObjectTypes
import ChartSortTypes from 'scoreboard/charts/model/chart-sort-types'
const { MANUAL, BY_LABEL, BY_VALUE } = ChartSortTypes
import './breakdown-by-field-type'
import { CATEGORY, VALUE } from './breakdown-by-field-type'

/**
 * Returns text to describe a ChartSortType setting, such as "Manually",
 * "By Value", "By Data Series Name", etc
 *
 * @param {ChartDesignerSortSettings} sortSettings
 *
 * @param {String} sortObjectType - option from sort-object-types.js indicating
 * what type of object is being sorted
 *
 * @returns {String} localized message
 */
function sortByText ({ sortSettings, sortObjectType }) {
	switch (sortSettings.get('sortType')) {
		case MANUAL: return i18n.get('charts.sort.type.manual')
		case BY_VALUE: return i18n.get('charts.sort.type.byValue')
		case BY_LABEL: return sortByLabelText({ sortObjectType })
	}
}

/**
 * Similar to sortByText(), but specifically for the BY_LABEL sort type
 */
function sortByLabelText ({ sortObjectType }) {
	return i18n.get(sortObjectType == SERIE
		? 'charts.sort.type.byLabel.serie'
		: 'charts.sort.type.byLabel.alphabetically')
}

/**
 * Returns an appropriate message for "Sort X" for the chart and type of object
 * being sorted, such as "Sort Data Series" or "Sort Salesperson Values"
 *
 * @param {ChartDesigner} chart
 *
 * @param {String} sortObjectType - option from sort-object-types.js indicating
 * what type of object is being sorted
 *
 * @returns {String} localized message
 */
function sortBlank ({ chart, sortObjectType }) {
	return blankMessage({ chart, sortObjectType, prefix: 'charts.sort.sortBlank.'})
}

/**
 * Returns an appropriate message for "X Sorting" for the chart and type of object
 * being sorted, such as "Data Series Sorting" or "Salesperson Sorting"
 *
 * @param {ChartDesigner} chart
 *
 * @param {String} sortObjectType - option from sort-object-types.js indicating
 * what type of object is being sorted
 *
 * @returns {String} localized message
 */
function blankSorting ({ chart, sortObjectType }) {
	return blankMessage({ chart, sortObjectType, prefix: 'charts.sort.blankSorting.'})
}

function blankMessage ({ chart, sortObjectType, prefix }) {
	if (sortObjectType == SERIE) {
		return i18n.get(prefix + 'bars')
	} else {
		let breakdown = chart.breakdowns.at(sortObjectType == BREAKDOWN1 ? 0 : 1)
		let breakdownBy = breakdown.get('breakdownBy')

		if (_.includes(['calendar-period-ranges', 'calendar-period-grouped-ranges'], breakdownBy)) {
			return i18n.get(prefix + 'periods')
		} else if (_.includes(['specific-values', 'every-value', 'specific-ranges', 'every-range'], breakdownBy)) {
			let dataset = chart.data.datasetModel(breakdown.get('datasetId'))
			let field = dataset.getFieldByIds({
				fieldId: breakdown.get('datasetFieldId'),
				visibleLinkedFieldId: breakdown.get('datasetVisibleLinkedFieldId')
			})

			let type = breakdownByFieldType({ field, breakdownBy })
			let suffix
			if (type === CATEGORY) {
				suffix = 'breakdownCatOrRange.text'
			} else if (type === CATEGORY) {
				suffix = 'breakdownCatOrRange.numeric'
			} else if (type === VALUE) {
				suffix = 'breakdownValues'
			}

			return i18n.get(prefix + suffix, field.label)
		} else {
			throw new Error('unsupported breakdownBy: ' + breakdownBy)
		}
	}
}

export { sortByText, sortByLabelText, sortBlank, blankSorting }
